export enum PositionEnum {
  // President /  Directeur général
  COMPANY_DIRECTOR = 'COMPANY_DIRECTOR',
  COMPANY_ACCOUNTANT = 'COMPANY_ACCOUNTANT',
  // responsable RH
  COMPANY_HUMAN_RESOURCE_MANAGER = 'COMPANY_HUMAN_RESOURCE_MANAGER',
  // responsable commercial
  COMPANY_SALES_ADMINISTRATOR = 'COMPANY_SALES_ADMINISTRATOR',
  // responsable marketing et communication
  COMPANY_MARKETING_MANAGER = 'COMPANY_MARKETING_MANAGER',
  // responsble IT
  COMPANY_IT_MANAGER = 'COMPANY_IT_MANAGER',
  // commercial
  COMPANY_COMMERCIAL = 'COMPANY_COMMERCIAL',
  // chargé de relations client
  COMPANY_CUSTOMER_SUCCESS = 'COMPANY_CUSTOMER_SUCCESS',
  // autres opérationnel
  COMPANY_OPERATIONAL = 'COMPANY_OPERATIONAL',
  // Président
  ASSOCIATION_PRESIDENT = 'ASSOCIATION_PRESIDENT',
  // trésorier
  ASSOCIATION_ACCOUNTANT = 'ASSOCIATION_ACCOUNTANT',
  // secrétaire
  ASSOCIATION_SECRETARY = 'ASSOCIATION_SECRETARY',
  OTHER = 'OTHER',
}
